var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHousekeeping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.89851 12.5832H7.07042C7.07042 11.2905 8.12158 10.2394 9.41423 10.2394V9.06745C8.12158 9.06745 7.07042 8.01629 7.07042 6.72363H5.89851C5.89851 8.01629 4.84734 9.06745 3.55469 9.06745V10.2394C4.84734 10.2394 5.89851 11.2905 5.89851 12.5832Z",
    fill: "#007FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.38288 19.6144H3.55479C3.55479 18.3218 4.60596 17.2706 5.89861 17.2706V16.0987C4.60596 16.0987 3.55479 15.0475 3.55479 13.7549H2.38288C2.38288 15.0475 1.29265 16.0987 0 16.0987V17.2706C1.29265 17.2706 2.38288 18.3218 2.38288 19.6144Z",
    fill: "#007FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0222 13.2414C19.3562 12.3247 18.881 11.3194 17.9716 10.9879L17.3273 10.7533C17.333 10.2328 17.0972 9.72599 16.6853 9.38563L20.0008 0.402824L18.8999 0L15.5836 8.9846C15.0553 8.98073 14.5474 9.21199 14.2115 9.61977L13.5666 9.38516C13.1265 9.22437 12.6488 9.24496 12.2225 9.44352C11.7973 9.64208 11.4745 9.99455 11.3138 10.4357L11.1133 10.9864L18.8217 13.792L19.0222 13.2414Z",
    fill: "#007FFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16765 14.3164L6.20117 14.2282L6.5731 15.1249C6.7751 15.6107 7.02917 16.0742 7.32843 16.5022C8.06947 17.5637 9.25911 18.2515 10.5861 18.4089V19.1047L10.9867 19.2381C11.5371 19.4223 12.0853 19.5533 12.6455 19.5116C14.3822 19.5116 16.0256 18.6555 17.0431 17.2216C17.5601 16.4932 17.9905 15.7013 18.3675 14.8742L10.7095 12.0869C10.1664 13.5418 8.71351 14.4529 7.16765 14.3164Z",
    fill: "#007FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHousekeeping);
export default __webpack_public_path__ + "static/media/housekeeping.c13c236eaefc3639b2d082fe11699c2e.svg";
export { ForwardRef as ReactComponent };